import Template from "../../component/Template.js";
import { useEffect, useRef } from "react";
import Api from "../../component/Api";
import { useState } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../component/useAuth.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "../../Assets/css/resptable.css";
import "../../Assets/css/responsiveptable.css";
import "datatables.net";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import Select from "react-select";
import html2pdf from "html2pdf.js";
import PdfTemplate from "../../component/Print1.js";
import ReactDOMServer from "react-dom/server";
import { set } from "date-fns";
import Loader from "../../component/Loader.js";
import { disciplineStyles } from "../../Assets/js/customStyles.js";

export default function CondonationSection() {
  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/admin/");
  }

  const tableRef = useRef(null);

  const [studentAccountid, setAccountid] = useState("");

  const [candidateType, setCandidateType] = useState(1);
  const collegename = localStorage.getItem("username");
  const [remark, setRemarks] = useState("");
  const [loading, setloading] = useState(false);
  const [loadinginner, setloadinginner] = useState(false);

  const [admissionYears, setAdmissionYears] = useState([]);
  const [admissionYear, setAdmissionYear] = useState(null);
  const [semesters, setSemesters] = useState([]);
  const [semester_id, setSemester] = useState(null);
  const [colleges, setColleges] = useState([]);
  const [college_id, setCollege] = useState(null);

  const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [disciplineId, setDisciplineId] = useState(null);

  const [flag, setflag] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);

  const [filteredStudents, setFilteredStudents] = useState([]);

  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);

  const [issaved, setissaved] = useState(1);
  const [status, setStatus] = useState(false);
  const [isFirstSubmit, setFirstSubmit] = useState(false);
  const [isFirstReject, setFirstReject] = useState(false);
  const [getApaarIDS, setApaarIDS] = useState([]);
  const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
  const [studentsForUpdate, setStudentsForUpdate] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentStudent, setCurrentStudent] = useState(null);
  const [condonationStatus, setCondonationStatus] = useState(null);
  const [stats, setStats] = useState(null);
  const [showForwardUtyModal, setShowForwardUtyModal] = useState(false);
  const [forwardUtyRemarks, setForwardUtyRemarks] = useState("");
  const [currentForwardStudent, setCurrentForwardStudent] = useState(null); // store student for which modal opened
  const [viewStudentData, setViewStudentData] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("condonation"); // default
  const [selectedDiscipline, setSelectedDiscipline] = useState("");
  const [condonationHours, setCondonationHours] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [individualAmount, setIndividualAmount] = useState([]);
  const [showRevertModal, setShowRevertModal] = useState(false);
  const [revertRemark, setRevertRemark] = useState("");
  const [currentRevertStudent, setCurrentRevertStudent] = useState(null);
  const [showViewRemarkModal, setShowViewRemarkModal] = useState(false);
  const [currentViewRemarkStudent, setCurrentViewRemarkStudent] = useState(null);
  const [eventStatus, setEventStatus] = useState('');

  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Holds the fetched students based on discipline
  const currentDate = new Date();

  const { http } = Api();

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: "150px",
      overflowY: "auto",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "150px",
      overflowY: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: "#888 #f1f1f1",
    }),

    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      "&::-webkit-scrollbar": {
        width: "8px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
  };

  const handleAdmissionYearChange = (selectedOption) => {
        const year = selectedOption?.value || null;
        setAdmissionYear(year);

         // 🔥 reset semester selection
        setSemester(null);

        // reset semester when year changes
        setSemesters([]);

        setCollege(null);
        setColleges([]);
    };

  const handleSemesterChange = (selectedOption) => {
        setSemester(selectedOption.value);
        setCollege(null);
        setColleges([]);
  };
 
  
  const handleCollegeChange = (selectedOption) => {
    const value = selectedOption?.value || null;
  
    setCollege(value);
  
    // 🔥 reset discipline completely
    setDisciplineData([]);
    setDisciplineId(null);
  
    setflag(false);
  };

  const handleDisciplineChange = (selectedOption) => {
    const { did, type, value } = selectedOption;
    setDisciplineId(did); // for API
    setDisciplineTypeChange(type); // for API
    setDisciplineNameChange(value); // display
    setSelectedDiscipline(selectedOption); // dropdown selected
  };

//-----------------Get All Admission Year

  useEffect(() => {
    const fetchAdmissionYears = async () => {
      try {
        const response = await http.get("/Admin/getActiveAdmissionYear");
        const years = response.data.map((year) => ({
          id: year.id,
          value: year.admission_year,
          label: year.admission_year,
        }));
        setAdmissionYears(years);
      } catch (error) {
        console.error("Error fetching admission years:", error);
      }
    };
    fetchAdmissionYears();
  }, []);

  //--------------------Get Semester

  useEffect(() => {
    if (!admissionYear) {
        setSemesters([]);
        return;
    }

    const fetchSemesters = async () => {
        try {
            const response = await http.get("/Admin/getAllSemesters", {
                params: { admissionyear: admissionYear },
            });

            const formatted = response.data.map((semester) => ({
              id: semester.id,
              value: semester.semester_no,
              label: semester.semester_no,
            }));
      
            setSemesters(formatted);
      
            // 🔥 auto-clear invalid old selection
            if (!formatted.find(s => s.value === semester_id)) {
              setSemester(null);
            }

        } catch (error) {
            console.error("Error fetching Semester", error);
        }
    };

    fetchSemesters();
}, [admissionYear]);

//--------------------Get Colleges

useEffect(() => {
    const fetchColleges = async () => {
      if (!admissionYear || !semester_id ) {
        setColleges([]);
        return;
      }
      try {
        const response = await http.get("/Admin/getAllColleges");
        const colleges = response.data.map((college) => ({
          value: college.college_id,
          label: college.college_name,
        }));
        setColleges(colleges);

      } catch (error) {
        console.error("Error fetching College:", error);
      }
    };
    fetchColleges();
  }, [admissionYear,semester_id]);

  //-------------------------Get Disciplines

  useEffect(() => {
    const fetchDisciplines = async () => {
      if (!admissionYear || !semester_id || !college_id) {
        setDisciplineData([]);
        setDisciplineId(null); // 🔥 important
        return;
      }
  
      try {
        const response = await http.get("/Admin/getAllCollegeDiscipline", {
          params: {
            college_id: college_id,
            admissionyear: admissionYear,
          },
        });
  
        const data = Array.isArray(response.data) ? response.data : [];
  
        setDisciplineData(data);
        setflag(data.length === 0);
  
        // 🔥 clear invalid old selection
        if (!data.find(d => d.discipline_id === disciplineId)) {
          setDisciplineId(null);
        }
  
      } catch (error) {
        console.error("Error fetching disciplines:", error);
        toast.error("Something went wrong");
  
        setDisciplineData([]);
        setDisciplineId(null);
        setflag(true);
      }
    };
  
    fetchDisciplines();
  }, [admissionYear, semester_id, college_id]);

  //--------------Get Statistics
  const fetchStatistics = async (
    year = admissionYear,
    sem = semester_id,
    collegeId=college_id,
    discipline = disciplineId,
    courseType = disciplinetype
  ) => {
    if (!year || !sem || !collegeId ) {
      setStats(null);
      return;
    }

    try {
      const response = await http.get("/Admin/getCollegeCondonationStatistics", {
        params: {
          admissionyear: year,
          semester: sem,
          college:collegeId,
          discipline_id: discipline ?? "", // empty = all
          college_course_type: courseType ?? "",
        },
      });

      if (response.data && response.data.statisticsData) {
        setStats(response.data.statisticsData);
      } else {
        setStats(null);
        toast.info("No statistics found");
      }
    } catch (error) {
      console.error("Error fetching statistics:", error);
      setStats(null);
      toast.error("Something went wrong while fetching statistics");
    }
  };
  useEffect(() => {
    fetchStatistics();
  }, [admissionYear, semester_id,college_id, disciplineId, disciplinetype]);

    // ----------------------- Listing students having Condonation
    const fetchStudents = async (
      year = admissionYear,
      sem = semester_id,
      collegeId=college_id,
      discipline = disciplineId,
      courseType = disciplinetype
    ) => {
      if (!year || !sem || !collegeId ) {
        setFilteredStudents([]);
        setSelectedStudents([]);
        return;
      }
      setIsSelectAllChecked(false);
      setloadinginner(true);
      try {
        const response = await http.get(
          "/Admin/geAllCondonationStudentsList",
          {
            params: {
              admissionyear: admissionYear,
              semester: semester_id,
              discipline_id: discipline,
              college_course_type: courseType,
              college_id:collegeId
            },
          }
        );
  
        const { students, event_status } = response.data;
  
        if (students) {
          setFilteredStudents(Object.entries(students));
          setSelectedStudents([]);
        } else {
          setFilteredStudents([]);
          setSelectedStudents([]);
        }
  
        setStatus(event_status === "active");
      } catch (error) {
        console.error("Error fetching students:", error);
        setFilteredStudents([]);
        setStatus(false);
      }
      finally {
        setloadinginner(false);
      }
    };
  
    //-------------------List students doesn't have condonation

    const fetchEligibleStudents = async (
        year = admissionYear,
        sem = semester_id,
        collegeId=college_id,
        discipline = disciplineId,
        courseType = disciplinetype
      ) => {
        if (!year || !sem || !collegeId ) {
          setFilteredStudents([]);
          setSelectedStudents([]);
          return;
        }
        setIsSelectAllChecked(false);
        setloadinginner(true);
      try {
          
        const params = new URLSearchParams({
          admissionyear: year || "",
          semester: sem || "",
          discipline_id: discipline || "",
          college_course_type: courseType || "",
          college_id:collegeId
        }).toString();
  
        const response = await http.get(
          `/Admin/getAllEligibleStudentsList?${params}`
        );
  
        if (response.data?.students) {
          setFilteredStudents(Object.entries(response.data.students));
          setEventStatus(response.data.event_status); // ✅ add this line
        } else {
          setFilteredStudents([]);
          setEventStatus(''); // optional reset
        }
      } catch (error) {
        toast.error("Failed to fetch eligible students.");
        setFilteredStudents([]);
      }
      finally {
        setloadinginner(false);
      }
    };
  
    useEffect(() => {
      if (selectedFilter === "eligible") {
      fetchEligibleStudents();
      }
      else{
        fetchStudents();
      }
    }, [admissionYear, semester_id,college_id, disciplineId, disciplinetype]);
  
    
  //search
  const filteredData = filteredStudents.filter(([prn, student]) => {
    const lowerSearch = searchTerm?.toLowerCase() ?? "";

    const studentPrn = student?.prn?.toLowerCase?.() ?? "";
    const studentName = student?.studentname?.toLowerCase?.() ?? "";
    const apaarNo = student?.apaar_no?.toLowerCase?.() ?? "";

    if (semester_id === 3) {
      // Search by PRN, Name, or APAAR No
      return (
        studentPrn.includes(lowerSearch) ||
        studentName.includes(lowerSearch) ||
        apaarNo.includes(lowerSearch)
      );
    } else if (semester_id === 1) {
      // Ignore PRN — only search by Name or APAAR No
      return studentName.includes(lowerSearch) || apaarNo.includes(lowerSearch);
    } else {
      // Default: include all three fields
      return (
        studentPrn.includes(lowerSearch) ||
        studentName.includes(lowerSearch) ||
        apaarNo.includes(lowerSearch)
      );
    }
  });



  const handleStatusChange = (accountId, courseId, status) => {
    setCondonationStatus((prev) => ({
      ...prev,
      [accountId]: {
        ...prev[accountId],
        [courseId]: status,
      },
    }));

    // Reset hours if status is NOT 'condonation'
    if (status !== "condonation") {
      setCondonationHours((prev) => ({
        ...prev,
        [accountId]: {
          ...prev[accountId],
          [courseId]: "", // clear the value
        },
      }));
    }
  };


  const handleSaveCondonation = async () => {
    if (!currentStudent) return;

    const courseStatuses = {};
    const courseHours = {};
    let missingHours = false; // flag for validation

    currentStudent.courses.forEach((course) => {
      const status =
        condonationStatus[currentStudent.accountid]?.[course.course_id];
      const hours =
        condonationHours[currentStudent.accountid]?.[course.course_id] || "";

      if (status) {
        courseStatuses[course.course_id] = status;
        courseHours[course.course_id] = hours;

        //  Validation: if status = "condonation" but no valid hours entered
        if (status === "condonation" && (hours === "" || Number(hours) <= 0)) {
          missingHours = true;
        }
      }
    });

    //  Show toast and stop saving if missing hours
    if (missingHours) {
      toast.error("Please enter condonation hours for  condonation courses.");
      return;
    }

    try {
      const response =await http.post("/College/saveCondonationPrincipal", {
        accountid: currentStudent.accountid,
        semester: semester_id,
        statuses: courseStatuses,
        condonation_hours: courseHours,
      });

      //toast.success("Condonation statuses saved successfully");
      toast.success(response.data.message);
      setShowModal(false);

      // Update courses locally
      const updatedCourses = currentStudent.courses.map((course) => {
        const newStatus = courseStatuses[course.course_id];
        const newHours = courseHours[course.course_id];
        return newStatus
          ? {
            ...course,
            exam_reg_status: newStatus,
            condonation_hours: newHours,
            condonation_status: "saved_by_principal",
            status_message: newStatus,
          }
          : course;
      });

      setCurrentStudent((prev) => ({
        ...prev,
        courses: updatedCourses,
      }));

      // Tab switching
      const allEligible = updatedCourses.every(
        (course) => course.exam_reg_status === "eligible"
      );
      setSelectedFilter(allEligible ? "eligible" : "condonation");

      if (allEligible) fetchEligibleStudents();
      else fetchStudents();

      fetchStatistics();
    } catch (error) {
      console.error("Error saving condonation status:", error);
      toast.error("Failed to save condonation status");
    }
  };

  //api for submit buttons
  const handlePrincipalAction = async (accountid, submitType, remarks = "") => {
    if (!accountid || !semester_id) return;

    // Handle view_remark separately since it doesn't need API call
    if (submitType === "view_remark") {
      return;
    }

    try {

       // ⭐ Make remarks mandatory for specific actions
        if (
          (submitType === "forward_uty" || submitType === "principal_revert") &&
          (!remarks || remarks.trim() === "")
        ) {
          toast.error("Remarks field is mandatory");
          return ;
        }

      const payload = {
        accountid,
        semester: semester_id,
        submit_type: submitType,
        ...(submitType === "forward_uty" && { remarks }),
        ...(submitType === "principal_revert" && { revert_remarks: remarks }),
      };

      await http.post("/College/updatePrincipalCondonationStatus", payload);

      // 🔥 Toast message based on action
      if (submitType === "forward_uty") {
        toast.success("Forwarded To University Successfully");
      } else if (submitType === "principal_revert") {
        toast.success("Reverted to student");
        setShowRevertModal(false);
      } else if (submitType === "principal_approve") {
        toast.success("Approved successfully");
      } else {
        toast.success("Action completed successfully");
      }

      // Refresh UI
      setShowForwardUtyModal(false);
      setForwardUtyRemarks(""); // Reset after submit
      await fetchStudents();
      await fetchStatistics();
    } catch (error) {
      console.error("Error updating or fetching student data:", error);
      toast.error("Failed to perform action");
    }
  };

  //view student condonation file
  const handleViewStudent = async (accountid) => {
    try {
      const response = await http.get("College/viewStudentApplication", {
        params: {
          accountid,
          semester: semester_id,
          admissionyear: admissionYear,
        },
      });

      const student = Object.values(response.data.student_details)[0];
      setAccountid(student.accountid);

      // Merge documents + remarks into student object for easy access
      student.documents = response.data.documents || [];
      student.reason_remarks = response.data.reason_remarks || [];
      student.payment_details = response.data.payment_details || [];

      setIndividualAmount(student.payment_details.amount);

      setViewStudentData(student);
      setShowViewModal(true);
    } catch (error) {
      console.error("Error fetching student data:", error);
      toast.error("Failed to fetch student details");
    }
  };
  // For preview modal

  const handlePreview = (file) => {
    try {
      if (!file) {
        toast.error("Invalid file data");
        return;
      }

      const { http } = Api();
      const apiBaseUrl = http.defaults.baseURL || window.location.origin;
      const domainUrl = apiBaseUrl.replace("/api/", "/").replace(/\/$/, "");

      let fileURL = file.url?.startsWith("http")
        ? file.url
        : `${domainUrl}${file.url?.startsWith("/") ? file.url : "/" + file.url
        }`;

      fileURL = `${fileURL}#toolbar=0&navpanes=0&scrollbar=0`;

      setPreviewFile({
        doc_id: file.doc_id || file.id || null, // ✅ added doc_id support
        name: file.docu_name || file.name || "Document",
        url: fileURL,
      });
    } catch (error) {
      console.error("Error in handlePreview:", error);
      toast.error("Unable to preview this file");
    }
  };

  const closePreview = () => {
    if (previewFile?.url && previewFile.url.startsWith("blob:")) {
      URL.revokeObjectURL(previewFile.url);
    }
    setPreviewFile(null);
  };

  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };
  // Reset when filteredStudents changes (when API data changes for different tabs)
  useEffect(() => {
    setCurrentPage(1);
  }, [filteredStudents]);

  // Reset when searchTerm changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const totalCondonationMinutes = currentStudent
    ? Object.values(condonationHours[currentStudent.accountid] || {}).reduce(
      (sum, value) => {
        if (!value) return sum;

        const num = parseFloat(value);
        const parts = value.toString().split(".");

        let hours = parseInt(parts[0]) || 0;
        let minutes = parseInt(parts[1]) || 0;

        // If user entered 49.30, treat 30 as minutes not 0.3 hour
        if (minutes > 59) {
          // normalize values like 49.75 → 49h 75m → 50h 15m
          hours += Math.floor(minutes / 60);
          minutes = minutes % 60;
        }

        return sum + hours * 60 + minutes;
      },
      0
    )
    : 0;

  // Convert to hours for display (optional)
  const totalCondonationHours = totalCondonationMinutes / 60;

  //  Check and warn if exceeds 50 hours (3000 minutes)
  useEffect(() => {
    if (totalCondonationMinutes > 3000) {
      toast.warning("Total condonation hours exceeded 50-hour limit!");
    }
  }, [totalCondonationMinutes]);

  // Convert total minutes back to HH.MM format for display
  const displayTotalCondonationHours = (() => {
    const hours = Math.floor(totalCondonationMinutes / 60);
    const minutes = totalCondonationMinutes % 60;
    // Pad minutes to 2 digits
    return `${hours}.${minutes.toString().padStart(2, "0")}`;
  })();

  const handleCloseModal = () => {
    setShowModal(false);

    setCondonationStatus({}); // clear selected statuses
    setCondonationHours({}); //  clears entered hour values
  };

  useEffect(() => {
    setSearchTerm("");
  }, [selectedFilter]);

  const handleOpenPDF = async (file) => {
    try {
      if (!file.doc_id || String(file.doc_id).startsWith("temp_")) return;

      const { http } = Api(); // your Axios instance

      const response = await http.get(
        `College/viewPrincipalCondonationPDF?doc_id=${file.doc_id}`,
        {
          responseType: "blob",
          headers: { Accept: "application/pdf" },
        }
      );

      if (response.data && response.data.type === "application/pdf") {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(blob);

        window.open(fileURL, "_blank", "noopener,noreferrer");

        setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
      } else {
        throw new Error("Invalid PDF response");
      }
    } catch (error) {
      console.error("Error opening PDF:", error);
    }
  };

  const generateCondonationPdf = async () => {
    try {
      const { http } = Api();

      const response = await http.get("/Student/generateCondonationPdf", {
        params: {
          accountid: studentAccountid,
          semester: semester_id,
        },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "CondonationSummary.pdf"; // optional rename
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Unable to download PDF");
    }
  };

  const handleCertificateDownload = async (accountid, semester) => {
    try {
      const { http } = Api();

      const response = await http.get("College/condonationCertificatePdf", {
        params: {
          accountid: accountid,
          semester: semester,
        },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "CondonationCertificate.pdf";
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Unable to download certificate");
    }
  };

  return (
    <>
      <ToastContainer />
      <Template>
        {loading ? (
          <Loader />
        ) : (
          <div className="my-page">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Condonation</h5>
                          
                        </div>
                      </div>
                      <div
                        className={`card-body ${isFirstSubmit || isFirstReject
                          ? "blur-background"
                          : ""
                          }`.trim()}
                      >
                        <div className="card-body pdg">
                          <div className="table-responsive">
                            <div className="form theme-form">
                              <div className="card-body custom-input">
                                <div className="row">
                                  <div className="col-md-2">
                                    <label>
                                      Admission Year{" "}
                                      <span className="errorclr">*</span>
                                    </label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="admissionyear"
                                      name="admissionyear"
                                      className="form"
                                      styles={customStyles}
                                      options={admissionYears}
                                      onChange={handleAdmissionYearChange}
                                    />
                                  </div>

                                  <div className="col-md-2">
                                    <label>
                                      Semester{" "}
                                      <span className="errorclr">*</span>
                                    </label>
                                    <Select
                                      maxMenuHeight={150}
                                      menuPlacement="auto"
                                      id="semester"
                                      name="semester"
                                      className="form"
                                      styles={customStyles}
                                      options={semesters}
                                      value={semesters.find(s => s.value === semester_id) || null}
                                      onChange={handleSemesterChange}
                                    />
                                  </div>

                                  <div className="col-md-3">
                                    <label>
                                      College{" "}
                                      <span className="errorclr">*</span> 
                                    </label>
                                    <Select
                                      maxMenuHeight={300}
                                      menuPlacement="auto"
                                      id="discipline_id"
                                      name="discipline_id"
                                      className="form"
                                      styles={customStyles}
                                      onChange={handleCollegeChange}
                                      options={colleges}
                                      value={colleges.find(s => s.value === college_id) || null}
                                    />
                                  </div>

                                  <div className="col-md-3">
                                    <label>
                                      Discipline{" "}
                                       {/* <span className="errorclr">*</span> */}
                                    </label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="discipline_id"
                                      name="discipline_id"
                                      className="form"
                                      styles={disciplineStyles}

                                      options={
                                        flag
                                          ? [{ value: "0", label: "No Data Found" }]
                                          : disciplinedata.map((d) => ({
                                              did: d.discipline_id,
                                              value: d.discipline_name,
                                              label: d.discipline_name,
                                              type: d.college_course_type,
                                            }))
                                      }

                                       // ✅ CONTROLLED VALUE (match BOTH id + type)
                                    value={
                                      disciplinedata
                                        .map((d) => ({
                                          did: d.discipline_id,
                                          value: d.discipline_name,
                                          label: d.discipline_name,
                                          type: d.college_course_type,
                                        }))
                                        .find(
                                          (d) =>
                                            d.did === disciplineId &&
                                            d.type === disciplinetype   // 🔥 added condition
                                        ) || null
                                    }

                                      onChange={handleDisciplineChange}
                                    />
                                  </div>
                                </div>

                                <div className="table-responsive mb-4">
                                  <table className="table table-striped table-bordered text-center  mb-0">
                                    <thead>
                                      <tr className="bg-primary text-white">
                                        <th className="fw-bold" scope="col">
                                          Total Students
                                        </th>
                                        <th className="fw-bold" scope="col">
                                          Condonation/Ineligible
                                        </th>
                                        <th className="fw-bold">
                                          Forwarded To Student
                                        </th>
                                        <th className="fw-bold">
                                          Application Submitted By Student
                                        </th>
                                        <th className="fw-bold">
                                          Forwarded To University
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="fw-bold fs-5">
                                        <td>
                                          {stats
                                            ? stats.total_registrations
                                            : "0"}
                                        </td>
                                        <td>
                                          {stats
                                            ? stats.condonation_or_ineligible_count
                                            : "0"}
                                        </td>
                                        <td>
                                          {stats
                                            ? stats.frwd_to_stud_count
                                            : "0"}
                                        </td>
                                        <td>
                                          {stats
                                            ? stats.student_submitted_count
                                            : "0"}
                                        </td>
                                        <td>
                                          {stats ? stats.frwd_uty_count : "0"}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div className="row col-md-12">
                                  <div className="card-body">
                                    <ul className="simple-wrapper nav nav-tabs">
                                      {/* Condonation/Ineligible Tab */}
                                      <li className="nav-item">
                                        <a class="nav-link txt-primary" id="home-tab" 
                                        className={`nav-link  ${selectedFilter === "condonation"
                                          ? "active border-0"
                                          : "text-dark"
                                          }`}
                                        onClick={() => {
                                          setSelectedFilter("condonation");
                                          fetchStudents(); // initial click should load list
                                        }}
                                        data-bs-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="false" tabindex="-1">
                                          Condonation / Ineligible</a>
                                        
                                      </li>

                                      {/* Eligible Tab */}
                                      <li className="nav-item">
                                      <a class="nav-link txt-primary" id="home-tab" 
                                         className={`nav-link  ${selectedFilter === "eligible"
                                          ? "active border-0"
                                          : "text-dark"
                                          }`}
                                        onClick={() => {
                                          setSelectedFilter("eligible");
                                          fetchEligibleStudents();
                                        }}
                                        data-bs-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="false" tabindex="-1">
                                          Eligible</a>
                                        
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                               
                                <div class="table-container">

                                  <div className="col-md-12 d-flex justify-content-between align-items-center flex-wrap mb-2">
                                  <div className="d-flex align-items-center gap-2">
                                    <label
                                      htmlFor="itemsPerPage"
                                      className="mb-0"
                                    >
                                      Show
                                    </label>
                                    <select
                                      id="itemsPerPage"
                                      value={itemsPerPage}
                                      onChange={handleItemsPerPageChange}
                                      className="form-select form-select-sm"
                                      style={{
                                        width: "auto",
                                        minWidth: "70px",
                                        paddingRight: "30px",
                                      }}
                                    >
                                      <option value={50}>50</option>
                                      <option value={100}>100</option>
                                      <option value={250}>250</option>
                                      <option value={500}>500</option>
                                    </select>
                                    <span className="text-muted">entries</span>
                                  
                                    </div>
                                   {/*search*/}
                                <div >
                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ maxWidth: "300px" }}
                                    placeholder="Search"
                                    value={searchTerm}
                                    onChange={(e) =>
                                      setSearchTerm(e.target.value)
                                    }
                                  />
                                </div>
                                </div>
                                  {loadinginner ? (
                                    <div className="text-center my-4">
                                     <div className="container-fluid">
                                        <div className="row justify-content-center align-items-center">
                                          <div className="col-sm-12">
                                            <div className="card ">
                                              <div className="card-body d-flex justify-content-center align-items-center" >
                                                <div className="containeranimate">
                                                  <div className="dot"></div>
                                                  <div className="dot"></div>
                                                  <div className="dot"></div>
                                                  <div className="dot"></div>
                                                  <div className="dot"></div>
                                                  <div className="dot"></div>
                                                  <div className="dot"></div>
                                                  <div className="dot"></div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                   </div>
                                  ) : (
                                  <table
                                    className="display dataTable table-striped table-bordered ex-v-table"
                                    ref={tableRef}
                                    id="dataTable"
                                  >
                                    <thead>
                                      <tr className="bg-primary">
                                        <th scope="col" width="18%">
                                          Prn / Apaar ID
                                        </th>
                                        <th scope="col" width="20%">
                                          Name
                                        </th>
                                        <th scope="col" width="60%">
                                          Courses
                                        </th>
                                        <th scope="col" width="25%">
                                          Action
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {filteredStudents.length > 0 ? (
                                        currentItems.map(
                                          ([prn, students], index) => (
                                            <tr key={prn}>
                                              <td data-label="PRN">
                                                {students.prn}
                                                <br />
                                                {students.apaar_no}
                                              </td>
                                              <td data-label="Name">
                                                {students.studentname}
                                              </td>
                                              <td data-label="Courses">
                                                <div className="treeview">
                                                  <ul>
                                                    {students.courses.map(
                                                      (courses, index) => (
                                                        <li key={index}>
                                                          {courses.course_code}{" "}
                                                          :{" "}
                                                          {courses.course_name}{" "}
                                                          &nbsp;
                                                          <span
                                                            className={`badge rounded-pill text-white ${courses.exam_reg_status ===
                                                              "eligible"
                                                              ? "bg-success"
                                                              : courses.exam_reg_status ===
                                                                "ineligible"
                                                                ? "bg-danger"
                                                                : "bg-warning"
                                                              }`}
                                                          >
                                                            {
                                                              courses.exam_reg_status
                                                            }
                                                          </span>
                                                        </li>
                                                      )
                                                    )}
                                                  </ul>
                                                </div>
                                              </td>
                                              <td data-label=" " className="text-center">
                                                <div className="d-inline-flex align-items-center gap-2 flex-wrap justify-content-center">

                                                  {/* MAIN BUTTON */}
                                                  {students.btn_view === 1 && (
                                                    <button
                                                      className="btn btn-sm btn-info"
                                                      type="button"
                                                      onClick={() => handleViewStudent(students.accountid)}
                                                    >
                                                      <i className="fa fa-eye me-1"></i> View
                                                    </button>
                                                  )}

                                                  {/* ACTIONS DROPDOWN - Only show if there are any actions available */}
                                                  {(students.btn_modify === 1 &&  eventStatus==='active' &&
                                                    (students.courses?.length > 0 /* chnage to view modify
                                                      &&
                                                      students.courses.every(
                                                        (course) => course.exam_reg_status === "eligible"
                                                      ) */) || students.reg_modify==1 ||
                                                    students.btn_fwd_stud === 1 ||
                                                    students.btn_fwd_uty === 1 ||
                                                    students.btn_principal_aprv === 1 ||
                                                    students.btn_sec_remark === 1 ||
                                                    students.btn_revert === 1) && (
                                                      <div className="dropdown" style={{ position: 'relative' }}>
                                                        <button
                                                          className="btn btn-sm btn-primary dropdown-toggle d-inline-flex align-items-center"
                                                          type="button"
                                                          data-bs-toggle="dropdown"
                                                          aria-expanded="false"
                                                          style={{
                                                            borderRadius: "8px",
                                                            padding: "6px 12px",
                                                            fontWeight: 500,
                                                            fontSize: "13px",
                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
                                                            gap: "6px",
                                                            whiteSpace: "nowrap",
                                                          }}
                                                        >
                                                          <i className="fa fa-hexagon"></i> Actions 
                                                        </button>

                                                        <ul
                                                          className="dropdown-menu dropdown-menu-end"
                                                          style={{
                                                            minWidth: "220px",
                                                            maxWidth: "240px",
                                                            borderRadius: "10px",
                                                            padding: "6px",
                                                            border: "1px solid rgba(0,0,0,0.08)",
                                                            boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                            marginTop: "4px",
                                                            zIndex: 1050, // Ensures dropdown appears above pagination
                                                          }}
                                                        >
                                                          
                                                          {/* MODIFY */}
                                                          {(students.btn_modify === 1 ||
                                                            (students.courses?.length > 0 &&
                                                              students.courses.every(
                                                                (course) => course.exam_reg_status === "eligible"
                                                              ))) && (
                                                              <li>
                                                                <button
                                                                  className="dropdown-item d-flex align-items-center"
                                                                  type="button"
                                                                  style={{
                                                                    borderRadius: "8px",
                                                                    padding: "8px 10px",
                                                                    fontWeight: 500,
                                                                    fontSize: "13px",
                                                                    gap: "10px",
                                                                    transition: "all 0.2s ease",
                                                                  }}
                                                                  onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "rgba(13,110,253,0.08)";
                                                                  }}
                                                                  onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "transparent";
                                                                  }}
                                                                  onClick={() => {
                                                                    const initialStatuses = {};
                                                                    const initialHours = {};

                                                                    students.courses.forEach((course) => {
                                                                      const statusValue = course.exam_reg_status || "eligible";
                                                                      initialHours[course.course_id] = course.condonation_hours || "";
                                                                      initialStatuses[course.course_id] = statusValue;
                                                                    });

                                                                    setCurrentStudent(students);
                                                                    setCondonationStatus((prev) => ({
                                                                      ...prev,
                                                                      [students.accountid]: initialStatuses,
                                                                    }));
                                                                    setCondonationHours((prev) => ({
                                                                      ...prev,
                                                                      [students.accountid]: initialHours,
                                                                    }));
                                                                    setShowModal(true);
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      width: "28px",
                                                                      height: "28px",
                                                                      borderRadius: "6px",
                                                                      background: "rgba(13,110,253,0.1)",
                                                                      display: "flex",
                                                                      alignItems: "center",
                                                                      justifyContent: "center",
                                                                      flexShrink: 0,
                                                                    }}
                                                                  >
                                                                    <i className="fa fa-edit text-primary" style={{ fontSize: "12px" }}></i>
                                                                  </span>
                                                                  <span>Modify</span>
                                                                </button>
                                                              </li>
                                                            )}

                                                          {/* FORWARD TO STUDENT */}
                                                          {students.btn_fwd_stud === 1 && (
                                                            <li>
                                                              <button
                                                                className="dropdown-item d-flex align-items-center"
                                                                type="button"
                                                                style={{
                                                                  borderRadius: "8px",
                                                                  padding: "8px 10px",
                                                                  fontWeight: 500,
                                                                  fontSize: "13px",
                                                                  gap: "10px",
                                                                  transition: "all 0.2s ease",
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                  e.currentTarget.style.backgroundColor = "rgba(25,135,84,0.08)";
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                  e.currentTarget.style.backgroundColor = "transparent";
                                                                }}
                                                                onClick={() =>
                                                                  handlePrincipalAction(students.accountid, "forward_student")
                                                                }
                                                              >
                                                                <span
                                                                  style={{
                                                                    width: "28px",
                                                                    height: "28px",
                                                                    borderRadius: "6px",
                                                                    background: "rgba(25,135,84,0.1)",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    flexShrink: 0,
                                                                  }}
                                                                >
                                                                  <i className="fa fa-paper-plane text-success" style={{ fontSize: "12px" }}></i>
                                                                </span>
                                                                <span>Forward to Student</span>
                                                              </button>
                                                            </li>
                                                          )}

                                                          {/* FORWARD TO UNIVERSITY */}
                                                          {students.btn_fwd_uty === 1 && (
                                                            <li>
                                                              <button
                                                                className="dropdown-item d-flex align-items-center"
                                                                type="button"
                                                                style={{
                                                                  borderRadius: "8px",
                                                                  padding: "8px 10px",
                                                                  fontWeight: 500,
                                                                  fontSize: "13px",
                                                                  gap: "10px",
                                                                  transition: "all 0.2s ease",
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                  e.currentTarget.style.backgroundColor = "rgba(13,110,253,0.08)";
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                  e.currentTarget.style.backgroundColor = "transparent";
                                                                }}
                                                                onClick={() => {
                                                                  setCurrentForwardStudent(students);
                                                                  setShowForwardUtyModal(true);
                                                                }}
                                                              >
                                                                <span
                                                                  style={{
                                                                    width: "28px",
                                                                    height: "28px",
                                                                    borderRadius: "6px",
                                                                    background: "rgba(13,110,253,0.1)",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    flexShrink: 0,
                                                                  }}
                                                                >
                                                                  <i className="fa fa-university text-primary" style={{ fontSize: "12px" }}></i>
                                                                </span>
                                                                <span>Forward to University</span>
                                                              </button>
                                                            </li>
                                                          )}

                                                          {/* APPROVE */}
                                                          {students.btn_principal_aprv === 1 && students.has_condonation === 0 && (
                                                            <>
                                                              
                                                              <li>
                                                                <button
                                                                  className="dropdown-item d-flex align-items-center"
                                                                  type="button"
                                                                  style={{
                                                                    borderRadius: "8px",
                                                                    padding: "8px 10px",
                                                                    fontWeight: 500,
                                                                    fontSize: "13px",
                                                                    gap: "10px",
                                                                    transition: "all 0.2s ease",
                                                                  }}
                                                                  onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "rgba(255,193,7,0.08)";
                                                                  }}
                                                                  onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "transparent";
                                                                  }}
                                                                  onClick={() =>
                                                                    handlePrincipalAction(students.accountid, "principal_approve")
                                                                  }
                                                                >
                                                                  <span
                                                                    style={{
                                                                      width: "28px",
                                                                      height: "28px",
                                                                      borderRadius: "6px",
                                                                      background: "rgba(255,193,7,0.12)",
                                                                      display: "flex",
                                                                      alignItems: "center",
                                                                      justifyContent: "center",
                                                                      flexShrink: 0,
                                                                    }}
                                                                  >
                                                                    <i className="fa fa-check-circle text-warning" style={{ fontSize: "12px" }}></i>
                                                                  </span>
                                                                  <span>Approve</span>
                                                                </button>
                                                              </li>
                                                            </>
                                                          )}

                                                          {/* VIEW REMARK */}
                                                          {students.btn_sec_remark === 1 && (
                                                            <>
                                                             
                                                              <li>
                                                                <button
                                                                  className="dropdown-item d-flex align-items-center"
                                                                  type="button"
                                                                  style={{
                                                                    borderRadius: "8px",
                                                                    padding: "8px 10px",
                                                                    fontWeight: 500,
                                                                    fontSize: "13px",
                                                                    gap: "10px",
                                                                    transition: "all 0.2s ease",
                                                                  }}
                                                                  onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "rgba(13,202,240,0.08)";
                                                                  }}
                                                                  onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "transparent";
                                                                  }}
                                                                  onClick={() => {
                                                                    setCurrentViewRemarkStudent(students);
                                                                    setShowViewRemarkModal(true);
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      width: "28px",
                                                                      height: "28px",
                                                                      borderRadius: "6px",
                                                                      background: "rgba(13,202,240,0.12)",
                                                                      display: "flex",
                                                                      alignItems: "center",
                                                                      justifyContent: "center",
                                                                      flexShrink: 0,
                                                                    }}
                                                                  >
                                                                    <i className="fa fa-commenting text-info" style={{ fontSize: "12px" }}></i>
                                                                  </span>
                                                                  <span>View Remark</span>
                                                                </button>
                                                              </li>
                                                            </>
                                                          )}

                                                          {/* REVERT */}
                                                          {students.btn_revert === 1 && (
                                                            <>
                                                              
                                                              <li>
                                                                <button
                                                                  className="dropdown-item d-flex align-items-center"
                                                                  type="button"
                                                                  style={{
                                                                    borderRadius: "8px",
                                                                    padding: "8px 10px",
                                                                    fontWeight: 500,
                                                                    fontSize: "13px",
                                                                    gap: "10px",
                                                                    transition: "all 0.2s ease",
                                                                  }}
                                                                  onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "rgba(220,53,69,0.08)";
                                                                  }}
                                                                  onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "transparent";
                                                                  }}
                                                                  onClick={() => {
                                                                    setCurrentRevertStudent(students);
                                                                    setShowRevertModal(true);
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      width: "28px",
                                                                      height: "28px",
                                                                      borderRadius: "6px",
                                                                      background: "rgba(220,53,69,0.1)",
                                                                      display: "flex",
                                                                      alignItems: "center",
                                                                      justifyContent: "center",
                                                                      flexShrink: 0,
                                                                    }}
                                                                  >
                                                                    <i className="fa fa-undo text-danger" style={{ fontSize: "12px" }}></i>
                                                                  </span>
                                                                  <span className="text-danger">Revert to Student</span>
                                                                </button>
                                                              </li>
                                                            </>
                                                          )}

                                                        </ul>
                                                      </div>
                                                    )}

                                                  {/* PRINT CERTIFICATE - Separate button outside dropdown */}
                                                  {students.btn_prt_cert ===
                                                    1 && (
                                                      <div
                                                        className="txt-aln"
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          handleCertificateDownload(
                                                            students.accountid,
                                                            semester_id
                                                          )
                                                        }
                                                      >
                                                        <i
                                                          className="fa fa-print icn-out-bod"
                                                          aria-hidden="true"
                                                          title="Print Certificate"
                                                        ></i>
                                                      </div>
                                                    )}

                                                </div>

                                                {students.action_message && (
                                                  <small
                                                    className={`d-block mt-1 ${students.reopen_status === 1 ? "text-danger" : "text-primary"
                                                      }`}
                                                      style={{ fontSize: "14px" }}

                                                  >
                                                    {students.action_message}
                                                  </small>
                                                )}
                                                  {students.reg_message && (
                                                    <small
                                                      className="d-block mt-1 text-success fw-bold"
                                                      style={{ fontSize: "12px" }}
                                                    >
                                                      {students.reg_message}
                                                    </small>
                                                  )}
                                              </td>

                                            </tr>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan="5"
                                            style={{ textAlign: "center" }}
                                          >
                                            No data available
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                  )}
                                  {filteredStudents.length > 0 && (
                                    <div className="mt-4 d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3">
                                      <div className="text-muted">
                                        Showing {indexOfFirstItem + 1} to{" "}
                                        {Math.min(
                                          indexOfLastItem,
                                          filteredData.length
                                        )}{" "}
                                        of {filteredData.length} entries
                                      </div>

                                      <nav>
                                        <ul className="pagination mb-0">
                                          <li
                                            className={`page-item ${currentPage === 1
                                              ? "disabled"
                                              : ""
                                              }`}
                                          >
                                            <button
                                              className="page-link"
                                              onClick={handlePreviousPage}
                                              disabled={currentPage === 1}
                                            >
                                              Previous
                                            </button>
                                          </li>

                                          {getPageNumbers().map(
                                            (pageNumber) => (
                                              <li
                                                key={pageNumber}
                                                className={`page-item ${currentPage === pageNumber
                                                  ? "active"
                                                  : ""
                                                  }`}
                                              >
                                                <button
                                                  className="page-link"
                                                  onClick={() =>
                                                    handlePageChange(pageNumber)
                                                  }
                                                >
                                                  {pageNumber}
                                                </button>
                                              </li>
                                            )
                                          )}

                                          <li
                                            className={`page-item ${currentPage === totalPages
                                              ? "disabled"
                                              : ""
                                              }`}
                                          >
                                            <button
                                              className="page-link"
                                              onClick={handleNextPage}
                                              disabled={
                                                currentPage === totalPages
                                              }
                                            >
                                              Next
                                            </button>
                                          </li>
                                        </ul>
                                      </nav>
                                    </div>
                                  )}
                                  {/* Forward to University Modal */}
                                  {showForwardUtyModal &&
                                    currentForwardStudent && (
                                      <div
                                        className="modal fade show"
                                        style={{
                                          display: "block",
                                          background: "rgba(0,0,0,0.5)",
                                        }}
                                      >
                                        <div className="modal-dialog modal-sm modal-dialog-centered">
                                          <div className="modal-content">
                                            <div className="modal-header">
                                              <h5 className="modal-title">
                                                Forward to University
                                              </h5>
                                              <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() =>
                                                  setShowForwardUtyModal(false)
                                                }
                                              ></button>
                                            </div>
                                            <div className="modal-body">
                                              <label
                                                htmlFor="remarks"
                                                className="form-label"
                                              >
                                                Remarks <span className="text-danger">*</span>
                                              </label>
                                              <textarea
                                                id="remarks"
                                                className="form-control"
                                                value={forwardUtyRemarks}
                                                onChange={(e) =>
                                                  setForwardUtyRemarks(
                                                    e.target.value
                                                  )
                                                }
                                                placeholder="Enter remarks here..."
                                                required={true}
                                              />
                                            </div>
                                            <div className="modal-footer">
                                              <button
                                                className="btn btn-secondary"
                                                onClick={() =>
                                                  setShowForwardUtyModal(false)
                                                }
                                              >
                                                Cancel
                                              </button>
                                              <button
                                                className="btn btn-success"
                                                onClick={() => {
                                                  handlePrincipalAction(
                                                    currentForwardStudent.accountid,
                                                    "forward_uty",
                                                    forwardUtyRemarks
                                                  );
                                                 // setShowForwardUtyModal(false);
                                                 // setForwardUtyRemarks(""); // Reset after submit
                                                }}
                                              >
                                                Submit
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}


                                  {showRevertModal && currentRevertStudent && (
                                    <div
                                      className="modal fade show"
                                      style={{
                                        display: "block",
                                        background: "rgba(0,0,0,0.5)",
                                      }}
                                    >
                                      <div className="modal-dialog modal-sm modal-dialog-centered">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5 className="modal-title">
                                              Revert to Student
                                            </h5>
                                            <button
                                              type="button"
                                              className="btn-close"
                                              onClick={() => setShowRevertModal(false)}
                                            ></button>
                                          </div>
                                          <div className="modal-body">
                                            <label
                                              htmlFor="revertRemarks"
                                              className="form-label"
                                            >
                                              Remarks <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                              id="revertRemarks"
                                              className="form-control"
                                              value={revertRemark}
                                              onChange={(e) => setRevertRemark(e.target.value)}
                                              placeholder="Enter reason for revert..."
                                            />
                                          </div>
                                          <div className="modal-footer">
                                            <button
                                              className="btn btn-secondary"
                                              onClick={() => setShowRevertModal(false)}
                                            >
                                              Cancel
                                            </button>
                                            <button
                                              className="btn btn-danger"
                                              onClick={() => {
                                                handlePrincipalAction(
                                                  currentRevertStudent.accountid,
                                                  "principal_revert",
                                                  revertRemark
                                                );
                                               // setShowRevertModal(false);
                                               // setRevertRemark(""); // Reset after submit
                                              }}
                                            >
                                              Submit
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {/* // View Student Modal */}
                                  {showViewModal && viewStudentData && (
                                    <div
                                      className="modal fade show d-flex align-items-center justify-content-center"
                                      style={{
                                        display: "flex",
                                        backgroundColor: "rgba(0,0,0,0.5)",
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        zIndex: 1050,
                                        padding: "1rem",
                                        boxSizing: "border-box",
                                      }}
                                    >
                                      <div
                                        className="modal-dialog"
                                        style={{
                                          width: "100%",
                                          maxWidth: "800px",
                                          margin: "auto",
                                          height: "95vh",
                                          maxHeight: "95vh",
                                        }}
                                      >
                                        <div
                                          className="modal-content"
                                          style={{
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            overflow: "hidden",
                                            width: "100%",
                                          }}
                                        >
                                          {/* Header */}
                                          <div
                                            className="modal-header"
                                            style={{
                                              position: "sticky",
                                              top: 0,
                                              zIndex: 1,
                                              background: "#fff",
                                            }}
                                          >
                                            <h5 className="modal-title text-truncate">
                                              <i className="fa fa-user me-2 text-primary"></i>
                                              {viewStudentData.studentname}{" "}
                                              <span className="text-muted">
                                                ({viewStudentData.prn})
                                              </span>
                                            </h5>
                                            <button
                                              type="button"
                                              className="btn-close"
                                              onClick={() =>
                                                setShowViewModal(false)
                                              }
                                            ></button>
                                          </div>

                                          {/* Body */}
                                          <div
                                            className="modal-body"
                                            style={{
                                              flex: 1,
                                              overflowY: "auto",
                                              WebkitOverflowScrolling: "touch",
                                              minHeight: 0,
                                            }}
                                          >
                                            {/* Courses */}
                                            <div className="mb-3 border rounded p-3 bg-light">
                                              <h6 className="fw-bold mb-3 text-dark">
                                                <i className="fa fa-book me-2 text-primary"></i>
                                                Courses Applied
                                              </h6>
                                              <div className="table-responsive">
                                                <table className="table table-bordered table-striped text-center ">
                                                  <thead>
                                                    <tr className="bg-primary text-white">
                                                      <th className="fw-bold">
                                                        Course Code
                                                      </th>
                                                      <th className="fw-bold">
                                                        Course Name
                                                      </th>
                                                      <th className="fw-bold">
                                                        Status Message
                                                      </th>
                                                      <th className="fw-bold">
                                                        Condonation Hours
                                                      </th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {viewStudentData.courses.map(
                                                      (course, idx) => (
                                                        <tr key={idx}>
                                                          <td>
                                                            {course.course_code}
                                                          </td>
                                                          <td>
                                                            {course.course_name}
                                                          </td>
                                                          <td>
                                                            {
                                                              course.status_message
                                                            }
                                                          </td>
                                                          <td className="text-center">
                                                            {course.condonation_time
                                                              ? `${course.condonation_time}`
                                                              : "—"}
                                                          </td>
                                                        </tr>
                                                      )
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>

                                            {/* Documents */}
                                            <div className="mb-3 border rounded p-3">
                                              <h6 className="fw-semibold mb-3">
                                                <i className="fa fa-file-pdf me-2 text-primary"></i>
                                                Uploaded Documents
                                              </h6>
                                              {viewStudentData.documents
                                                .length > 0 ? (
                                                <div className="row">
                                                  {viewStudentData.documents.map(
                                                    (doc, index) => (
                                                      <div
                                                        key={doc.id}
                                                        className="col-12 mb-2"
                                                      >
                                                        <div className="border rounded p-2 bg-light d-flex justify-content-between align-items-center">
                                                          <div>
                                                            <i className="fa fa-file-pdf text-danger me-2"></i>
                                                            <span className="fw-semibold text-black">
                                                              {doc.docu_name}
                                                            </span>
                                                            <span className="badge bg-primary ms-2">
                                                              #{index + 1}
                                                            </span>
                                                          </div>
                                                          <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-dark"
                                                            onClick={() =>
                                                              handlePreview(doc)
                                                            }
                                                          >
                                                            <i className="fa fa-eye me-1"></i>{" "}
                                                            Preview
                                                          </button>
                                                        </div>
                                                      </div>
                                                    )
                                                  )}
                                                </div>
                                              ) : (
                                                <p className="text-muted">
                                                  No documents available
                                                </p>
                                              )}
                                            </div>

                                            {/* Reason / Remarks */}
                                            <div className="mb-3 border rounded p-3">
                                              {viewStudentData.reason_remarks &&
                                                viewStudentData.reason_remarks
                                                  .length > 0 ? (
                                                viewStudentData.reason_remarks.map(
                                                  (r, index) => (
                                                    <div
                                                      key={r.id || index}
                                                      className="mb-3 border-bottom pb-2"
                                                    >
                                                      {/* Reason */}
                                                      <div className="mb-1">
                                                        <strong>Reason:</strong>{" "}
                                                        <span>
                                                          {r.reason || "—"}
                                                        </span>
                                                      </div>

                                                      {/* Other Reason (if available) */}
                                                      {r.other_reason && (
                                                        <div className="mb-1">
                                                          <strong>
                                                            Other Reason:
                                                          </strong>{" "}
                                                          <span>
                                                            {r.other_reason}
                                                          </span>
                                                        </div>
                                                      )}

                                                      {/* Remarks (if available) */}
                                                      {r.student_remarks && (
                                                        <div>
                                                          <strong>
                                                            Remarks:
                                                          </strong>{" "}
                                                          <span>
                                                            {r.student_remarks}
                                                          </span>
                                                        </div>
                                                      )}
                                                    </div>
                                                  )
                                                )
                                              ) : (
                                                <p className="text-muted mb-0">
                                                  No reasons provided
                                                </p>
                                              )}
                                            </div>
                                            <div className="mb-3 border rounded p-3">
                                              <div className="mb-1">
                                                <strong>Fee Amount:</strong>{" "}
                                                <span>
                                                  {individualAmount
                                                    ? `₹ ${individualAmount}`
                                                    : "—"}
                                                </span>
                                              </div>
                                            </div>
                                          </div>

                                          {/* Footer */}
                                          <div className="modal-footer">
                                           
                                            <button
                                              type="button"
                                              className="btn btn-primary"
                                              onClick={generateCondonationPdf}
                                              disabled={loading} // disable while loading
                                            >
                                              <i className="fa fa-print me-1"></i>
                                              {loading
                                                ? "Generating..."
                                                : "Print Application"}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {showViewRemarkModal && currentViewRemarkStudent && (
                                    <div
                                      className="modal fade show"
                                      style={{
                                        display: "block",
                                        background: "rgba(0,0,0,0.5)",
                                      }}
                                    >
                                      <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content" style={{ color: "#212529" }}>
                                          <div className="modal-header">
                                            <h5 className="modal-title">
                                              Reopen Remarks
                                            </h5>
                                            <button
                                              type="button"
                                              className="btn-close"
                                              onClick={() => setShowViewRemarkModal(false)}
                                            ></button>
                                          </div>
                                          <div className="modal-body">
                                            <div className="mb-3">
                                              <p className="mb-0">
                                                <span className="fw-bold">Student Name</span> :{" "}
                                                <span className="fw-semibold text-dark">
                                                  {currentViewRemarkStudent.studentname}
                                                </span>
                                              </p>
                                            </div>

                                            <div className="mb-3">
                                              <p className="mb-2">
                                                <span className="fw-bold">Remarks</span> :
                                              </p>

                                              <div
                                                className="p-3 bg-light rounded text-dark"
                                                style={{
                                                  minHeight: "100px",
                                                  whiteSpace: "pre-wrap",
                                                  wordBreak: "break-word",
                                                }}
                                              >
                                                {currentViewRemarkStudent.reopen_remarks || "No remarks available"}
                                              </div>
                                            </div>

                                          </div>
                                          <div className="modal-footer">
                                            <button
                                              className="btn btn-secondary"
                                              onClick={() => setShowViewRemarkModal(false)}
                                            >
                                              Close
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {/* PDF Preview Modal */}
                                  {previewFile && (
                                    <div
                                      className="modal fade show d-flex align-items-center justify-content-center p-1 p-md-4"
                                      style={{
                                        display: "flex",
                                        backgroundColor: "rgba(0,0,0,0.5)",
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        zIndex: 1060,
                                      }}
                                    >
                                      <div
                                        className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down"
                                        style={{
                                          height: "95vh",
                                          maxHeight: "95vh",
                                          width: "100%",
                                          maxWidth: "600px",
                                          margin: "auto",
                                        }}
                                      >
                                        <div
                                          className="modal-content"
                                          style={{
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          {/* Header */}
                                          <div
                                            className="modal-header p-2 p-md-3"
                                            style={{
                                              position: "sticky",
                                              top: 0,
                                              zIndex: 1,
                                              backgroundColor: "#fff",
                                              borderBottom: "1px solid #dee2e6",
                                            }}
                                          >
                                            <h5 className="modal-title fs-6 fs-md-5 text-truncate me-2">
                                              <i className="fa fa-file-pdf text-danger me-2"></i>
                                              {previewFile.name}
                                            </h5>
                                            <button
                                              type="button"
                                              className="btn-close"
                                              onClick={closePreview}
                                            ></button>
                                          </div>

                                          {/* Body */}
                                          <div
                                            className="modal-body p-0"
                                            style={{
                                              flex: "1 1 auto",
                                              overflow: "hidden",
                                              minHeight: 0,
                                            }}
                                          >
                                            <iframe
                                              src={previewFile.url}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                border: "none",
                                              }}
                                              title="PDF Preview"
                                            />
                                          </div>

                                          {/* Footer */}
                                          <div
                                            className="modal-footer p-2 p-md-3 d-flex justify-content-end"
                                            style={{
                                              position: "sticky",
                                              bottom: 0,
                                              zIndex: 1,
                                              backgroundColor: "#fff",
                                              borderTop: "1px solid #dee2e6",
                                            }}
                                          >
                                         
                                            {
                                              <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() =>
                                                  handleOpenPDF(previewFile)
                                                }
                                              >
                                                <i className="fa fa-external-link me-1"></i>{" "}
                                                Open in New Tab
                                              </button>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {showModal && currentStudent && (
                                    <div
                                      className="modal fade show d-flex align-items-center justify-content-center"
                                      style={{
                                        display: "flex",
                                        backgroundColor: "rgba(0,0,0,0.5)",
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        zIndex: 1050,
                                        padding: "1rem",
                                        boxSizing: "border-box",
                                      }}
                                    >
                                      <div
                                        className="modal-dialog"
                                        style={{
                                          width: "100%",
                                          maxWidth: "720px",
                                          margin: "auto",
                                          height: "95vh",
                                          maxHeight: "95vh",
                                        }}
                                      >
                                        <div
                                          className="modal-content"
                                          style={{
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            overflow: "hidden",
                                            width: "100%",
                                            backgroundColor: "#fff",
                                          }}
                                        >
                                          {/* Modal Header */}
                                          <div
                                            className="modal-header"
                                            style={{
                                              flexShrink: 0,
                                              backgroundColor: "#fff",
                                              zIndex: 2,
                                              borderBottom: "1px solid #dee2e6",
                                            }}
                                          >
                                            <div>
                                              <h5 className="modal-title">
                                                {currentStudent.studentname} -{" "}
                                                {currentStudent.prn}
                                              </h5>

                                              {currentStudent.eligible_for_condonation ===
                                                0 && (
                                                  <div className="d-flex align-items-center text-danger fw-bold mt-2">
                                                    <i className="bi bi-info-circle me-2"></i>
                                                    <small>
                                                      Condonation has already been
                                                      availed twice.
                                                    </small>
                                                  </div>
                                                )}
                                            </div>
                                            
                                          </div>

                                          {/* Modal Body */}
                                          <div
                                            className="modal-body"
                                            style={{
                                              flex: 1,
                                              overflowY: "auto",
                                              overflowX: "hidden",
                                              padding: 0,
                                              backgroundColor: "#fff",
                                            }}
                                          >
                                            <div
                                              style={{
                                                padding: "1rem",
                                                backgroundColor: "#fff",
                                              }}
                                            >
                                              <div className="table-responsive">
                                                <table className="table table-bordered table-striped text-center ex-v-table">
                                                  <thead>
                                                    <tr className="bg-primary text-white">
                                                      <th
                                                        style={{ width: "35%" }}
                                                        className="fw-bold text-center"
                                                      >
                                                        Course
                                                      </th>
                                                      <th
                                                        style={{ width: "22%" }}
                                                        className="fw-bold text-center"
                                                      >
                                                        Eligible For Exam
                                                      </th>
                                                      <th
                                                        style={{ width: "28%" }}
                                                        className="fw-bold text-center"
                                                      >
                                                        Eligible With
                                                        Condonation
                                                      </th>
                                                      <th
                                                        style={{ width: "20%" }}
                                                        className="fw-bold text-center"
                                                      >
                                                        Not Eligible
                                                      </th>
                                                      <th
                                                        style={{ width: "22%" }}
                                                        className="fw-bold text-center"
                                                      >
                                                        Condonation Hours
                                                      </th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {currentStudent.courses.map(
                                                      (course, index) => {
                                                        const selectedStatus =
                                                          condonationStatus[
                                                          currentStudent
                                                            .accountid
                                                          ]?.[
                                                          course.course_id
                                                          ] || "";
                                                        const enteredHours =
                                                          condonationHours[
                                                          currentStudent
                                                            .accountid
                                                          ]?.[
                                                          course.course_id
                                                          ] || "";

                                                        return (
                                                          <tr key={index}>
                                                            <td className="text-start align-middle">
                                                              <div className="d-flex flex-column">
                                                                <span>
                                                                  {
                                                                    course.course_code
                                                                  }
                                                                </span>
                                                                <span className="text-muted small">
                                                                  {
                                                                    course.course_name
                                                                  }
                                                                </span>
                                                              </div>
                                                            </td>

                                                            {/* Eligible Radio */}
                                                            <td className="align-middle text-center">
                                                              <input
                                                                type="radio"
                                                                name={`condonation_${course.course_id}`}
                                                                value="eligible"
                                                                checked={
                                                                  selectedStatus ===
                                                                  "eligible"
                                                                }
                                                                onChange={() =>
                                                                  handleStatusChange(
                                                                    currentStudent.accountid,
                                                                    course.course_id,
                                                                    "eligible"
                                                                  )
                                                                }
                                                                disabled={currentStudent.reopen_status == 1 || 
                                                                  (currentStudent.con_modify==0 && selectedStatus==='condonation')
                                                                }

                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              />
                                                            </td>

                                                            {/* Condonation Radio */}
                                                            <td className="align-middle text-center">
                                                              <input
                                                                type="radio"
                                                                name={`condonation_${course.course_id}`}
                                                                value="condonation"
                                                                checked={
                                                                  condonationStatus[
                                                                  currentStudent
                                                                    .accountid
                                                                  ]?.[
                                                                  course
                                                                    .course_id
                                                                  ] ===
                                                                  "condonation"
                                                                }
                                                                onChange={() =>
                                                                  handleStatusChange(
                                                                    currentStudent.accountid,
                                                                    course.course_id,
                                                                    "condonation"
                                                                  )
                                                                }
                                                                disabled={
                                                                  currentStudent.eligible_for_condonation ===
                                                                  0 || currentStudent.reopen_status === 1
                                                                }
                                                                title={
                                                                  currentStudent.eligible_for_condonation ===
                                                                    0
                                                                    ? "Condonation not allowed for this student"
                                                                    : ""
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    currentStudent.eligible_for_condonation ===
                                                                      0
                                                                      ? "not-allowed"
                                                                      : "pointer",
                                                                }}
                                                              />
                                                            </td>

                                                            {/* Ineligible Radio */}
                                                            <td className="align-middle text-center">
                                                              <input
                                                                type="radio"
                                                                name={`condonation_${course.course_id}`}
                                                                value="ineligible"
                                                                checked={
                                                                  selectedStatus ===
                                                                  "ineligible"
                                                                }
                                                                onChange={() =>
                                                                  handleStatusChange(
                                                                    currentStudent.accountid,
                                                                    course.course_id,
                                                                    "ineligible"
                                                                  )
                                                                }
                                                                disabled={currentStudent.reopen_status == 1 /* || currentStudent.reg_modify==1 || 
                                                                  (currentStudent.con_modify==0 && selectedStatus==='condonation') */}
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              />
                                                            </td>

                                                            {/* Condonation Hours Input */}
                                                            <td className="align-middle">
                                                              <div className="d-flex justify-content-center align-items-center gap-1">
                                                                <input
                                                                  type="text"
                                                                  className="form-control form-control-sm text-center"
                                                                  placeholder="H"
                                                                  style={{
                                                                    maxWidth:
                                                                      "45px",
                                                                    fontSize:
                                                                      "0.875rem",
                                                                  }}
                                                                  value={
                                                                    selectedStatus ===
                                                                      "condonation"
                                                                      ? (() => {
                                                                        const decimalValue =
                                                                          condonationHours[
                                                                          currentStudent
                                                                            .accountid
                                                                          ]?.[
                                                                          course
                                                                            .course_id
                                                                          ] ||
                                                                          "";
                                                                        if (
                                                                          !decimalValue
                                                                        )
                                                                          return "";
                                                                        const parts =
                                                                          decimalValue.split(
                                                                            "."
                                                                          );
                                                                        const hours =
                                                                          parts[0] ||
                                                                          "0";
                                                                        return hours ===
                                                                          "0"
                                                                          ? ""
                                                                          : hours;
                                                                      })()
                                                                      : ""
                                                                  }
                                                                  disabled={
                                                                    selectedStatus !==
                                                                    "condonation"
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    const hours =
                                                                      e.target
                                                                        .value;
                                                                    const regex =
                                                                      /^[0-9]{0,2}$/;

                                                                    if (
                                                                      !regex.test(
                                                                        hours
                                                                      )
                                                                    )
                                                                      return;

                                                                    const currentValue =
                                                                      condonationHours[
                                                                      currentStudent
                                                                        .accountid
                                                                      ]?.[
                                                                      course
                                                                        .course_id
                                                                      ] ||
                                                                      "0.00";
                                                                    const parts =
                                                                      currentValue.split(
                                                                        "."
                                                                      );
                                                                    const minutes =
                                                                      parts[1] ||
                                                                      "00";
                                                                    const newValue = `${hours ||
                                                                      "0"
                                                                      }.${minutes}`;

                                                                    setCondonationHours(
                                                                      (
                                                                        prev
                                                                      ) => ({
                                                                        ...prev,
                                                                        [currentStudent.accountid]:
                                                                        {
                                                                          ...prev[
                                                                          currentStudent
                                                                            .accountid
                                                                          ],
                                                                          [course.course_id]:
                                                                            newValue,
                                                                        },
                                                                      })
                                                                    );
                                                                  }}
                                                                />
                                                               
                                                              </div>
                                                            </td>
                                                          </tr>
                                                        );
                                                      }
                                                    )}
                                                  </tbody>
                                                </table>
                                                {/* </div> */}
                                              </div>
                                            </div>

                                            {/* Modal Footer */}
                                            <div
                                              className={`modal-footer flex-wrap ${totalCondonationHours > 0
                                                ? "justify-content-between"
                                                : ""
                                                }`}
                                              style={{
                                                position: "sticky",
                                                bottom: 0,
                                                background: "#fff",
                                                flexShrink: 0,
                                                zIndex: 2,
                                                borderTop: "1px solid #dee2e6",
                                              }}
                                            >
                                              {totalCondonationHours > 0 && (
                                                <div className="text fs-6">
                                                  <strong>Total Hours: </strong>
                                                  <span
                                                    className={
                                                      totalCondonationHours > 50
                                                        ? "text-danger fw-bold"
                                                        : "text-success fw-bold"
                                                    }
                                                  >
                                                    {
                                                      displayTotalCondonationHours
                                                    }
                                                    /50
                                                  </span>
                                                </div>
                                              )}
                                              <div>
                                                <button
                                                  className="btn btn-secondary me-2"
                                                  onClick={handleCloseModal}
                                                >
                                                  Close
                                                </button>
                                                <button
                                                  className="btn btn-primary"
                                                  onClick={
                                                    handleSaveCondonation
                                                  }
                                                  disabled={
                                                    totalCondonationHours > 50
                                                  }
                                                >
                                                  Save
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <style>{`
                                              @media (max-width: 768px) {
                                               .modal-dialog {
                                                 width: 95vw !important;
                                                 margin: 0.5rem auto;
                                                  }
                                                 }
                                                 `}</style>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-12 txt-aln "></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Template>
    </>
  );
}
